import {boundingExtent, Extent} from 'ol/extent';

export function getFlandersExtent(code: string): Extent {
    // export const projectionExtent72: Extent = [22000, 153000, 259000, 245000];
    // export const projectionExtent2008: Extent = [500000.0, 537856.0, 762144.0, 800000.0];

    if (code === 'EPSG:3812') {
        // return boundingExtent([[500000.0, 537856.0], [762144.0, 800000.0]]);
        return boundingExtent([[522000, 653000], [759000, 745000]]);
    }
    console.assert(code === 'EPSG:31370', `Unsupported projection: ${code}`);
    return boundingExtent([[22000, 153000], [259000, 245000]]);
}

export function getProjectionLabel(code: string): string {
    if (code === 'EPSG:3812') {
        return 'Lambert 2008';
    }
    console.assert(code === 'EPSG:31370', `Unsupported projection: ${code}`);
    return 'Lambert 72';
}
